import axios from 'axios/index'

import createAsyncConst from '../../util/createAsyncConst'
import action, { actionFailed } from '../../util/action'
import config from '../../config'
import { removeEmpty } from '../../util/utils'

export const FETCH_LAUNDRY_ALERTS_UNREAD = createAsyncConst(
  'FETCH_LAUNDRY_ALERTS_UNREAD'
)
export const FETCH_LAUNDRY_ALERTS = createAsyncConst('FETCH_LAUNDRY_ALERTS')
export const READ_LAUNDRY_ALERT = createAsyncConst('READ_LAUNDRY_ALERT')
export const READ_ALL_LAUNDRY_ALERTS = createAsyncConst(
  'READ_ALL_LAUNDRY_ALERTS'
)
export const REMOVE_LAUNDRY_ALERT = 'REMOVE_LAUNDRY_ALERT'

// Tudo aqui roda em segundo plano (sino do topo): sem o loading de tela cheia
export function fetchUnread() {
  return dispatch => {
    dispatch(action(FETCH_LAUNDRY_ALERTS_UNREAD.ACTION, {}, false, false))
    return axios
      .get(`${config.API_URL}/laundry-alerts/unread`)
      .then(resp => {
        dispatch(
          action(FETCH_LAUNDRY_ALERTS_UNREAD.SUCCESS, resp.data, false, false)
        )
        return resp.data
      })
      .catch(e => dispatch(actionFailed(FETCH_LAUNDRY_ALERTS_UNREAD, e, false)))
  }
}

export function fetchLaundryAlerts(filters = {}) {
  return dispatch => {
    dispatch(action(FETCH_LAUNDRY_ALERTS.ACTION, {}, false, false))
    return axios
      .get(`${config.API_URL}/laundry-alerts`, {
        params: removeEmpty(filters),
      })
      .then(resp => {
        dispatch(
          action(
            FETCH_LAUNDRY_ALERTS.SUCCESS,
            { data: resp.data, filters },
            false,
            false
          )
        )
        return resp.data
      })
      .catch(e => dispatch(actionFailed(FETCH_LAUNDRY_ALERTS, e, false)))
  }
}

export function readAlert(id) {
  return dispatch => {
    dispatch(action(READ_LAUNDRY_ALERT.ACTION, {}, false, false))
    return axios
      .post(`${config.API_URL}/laundry-alerts/${id}/read`)
      .then(() => {
        // Sem o `message` no payload para não abrir snackbar a cada leitura
        dispatch(action(READ_LAUNDRY_ALERT.SUCCESS, { id }, false, false))
      })
      .catch(e => {
        // 404: o admin excluiu o alerta
        if (e.response?.status === 404) {
          dispatch(action(REMOVE_LAUNDRY_ALERT, { id }, false, false))
          return
        }
        dispatch(actionFailed(READ_LAUNDRY_ALERT, e, false))
      })
  }
}

export function readAllAlerts() {
  return dispatch => {
    dispatch(action(READ_ALL_LAUNDRY_ALERTS.ACTION, {}, false, false))
    return axios
      .post(`${config.API_URL}/laundry-alerts/read-all`)
      .then(resp => {
        dispatch(
          action(READ_ALL_LAUNDRY_ALERTS.SUCCESS, resp.data, false, false)
        )
      })
      .catch(e => dispatch(actionFailed(READ_ALL_LAUNDRY_ALERTS, e, false)))
  }
}
